<input type="text" readonly [value]="format(_date)" (click)="open_calendar()" [ngClass]="{invalid: invalid}">
<div class="calendar" [ngClass]="{visible: show_calendar}" *ngIf="view_date">
	<p class="month">
		<span class="close" (click)="show_calendar = false">&times;</span>
		<span class="prev" (click)="show_month(view_date.getFullYear(), view_date.getMonth() - 1)">«</span>
		{{months[view_date.getMonth()]}} {{view_date.getFullYear()}}
		<span class="next" (click)="show_month(view_date.getFullYear(), view_date.getMonth() + 1)">»</span>
	</p>
	<table>
		<thead>
			<tr>
				<th>Sun</th>
				<th>Mon</th>
				<th>Tue</th>
				<th>Wed</th>
				<th>Thu</th>
				<th>Fri</th>
				<th>Sat</th>
			</tr>
			<tr *ngFor="let week of view_month">
				<td *ngFor="let day of week" (click)="select_date(day)" [ngClass]="{day: day != null, old: day < 0}">
					{{day < 0 ? -day : day}}
				</td>
			</tr>
		</thead>
	</table>
</div>
